var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createRef, useEffect } from 'react';
import '@gouvfr/dsfr/dist/component/modal/modal.min.css';
import { Col, Container, Row, SegmentLoader } from "../../index";
import ModaleContent from "./Content/ModaleContent";
import ModaleTitre from "./Content/ModaleTitre";
import ModaleFooter from "./Footer/ModaleFooter";
/**
 * @deprecated utiliser `ModalV2`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var Modale = function (_a) {
    var id = _a.id, children = _a.children, closeCallback = _a.closeCallback, _b = _a.taille, taille = _b === void 0 ? "md" : _b, isLoading = _a.isLoading, className = _a.className, otherProps = __rest(_a, ["id", "children", "closeCallback", "taille", "isLoading", "className"]);
    var modaleRef = createRef();
    var onClickEchap = function (keydown) {
        if (keydown.code === "Escape" && !isLoading) {
            close();
        }
    };
    var onClickOutside = function (event) {
        if (modaleRef &&
            modaleRef.current &&
            !modaleRef.current.contains(event.target) &&
            !isLoading) {
            close();
        }
    };
    var close = function () {
        document.body.style.overflow = '';
        if (closeCallback)
            closeCallback();
    };
    useEffect(function () {
        /*
            Si la modale est ouverte via une action externe,
            on ajoute les contrôles pour la fermeture via échap ou un clique en dehors de la modale.
            on désactive le scroll sur la page.
            */
        window.addEventListener("keydown", onClickEchap);
        document.addEventListener("mousedown", onClickOutside);
        document.body.style.overflow = 'hidden';
        return function unmount() {
            /*
                  A la fermeture de la modale,
                  on enlève les contrôles pour la fermeture via échap ou un clique en dehors de la modale.
                   */
            window.removeEventListener("keydown", onClickEchap);
            document.removeEventListener("mousedown", onClickOutside);
            document.body.style.overflow = '';
        };
    }, [modaleRef, closeCallback]);
    var modaleContent = null;
    var modaleTitre = null;
    var modaleFooter = null;
    var recupererElement = function (child) {
        switch (child.type) {
            case ModaleContent:
                modaleContent = child;
                break;
            case ModaleTitre:
                modaleTitre = child;
                break;
            case ModaleFooter:
                modaleFooter = child;
                break;
        }
    };
    if (Array.isArray(children)) {
        children.forEach(function (child) {
            recupererElement(child);
        });
    }
    else {
        recupererElement(children);
    }
    var taillemd = 6;
    if (taille === "sm") {
        taillemd = 4;
    }
    else if (taille === "lg") {
        taillemd = 8;
    }
    return (React.createElement("dialog", __assign({}, otherProps, { "aria-labelledby": "fr-modal-title-".concat(id), id: id, className: "".concat(className, " fr-modal fr-modal--opened") }),
        React.createElement(Container, { margeExterne: true },
            React.createElement(Row, { alignementHorizontal: "center" },
                React.createElement(Col, { col: 12, md: taillemd },
                    React.createElement(SegmentLoader, { isLoading: isLoading },
                        React.createElement("div", { className: "fr-modal__body", ref: modaleRef },
                            React.createElement("div", { className: "fr-modal__header" }, closeCallback ? React.createElement("button", { type: "button", className: "fr-link fr-link--close", title: "Fermer", "aria-controls": id, "aria-label": "Close", onClick: close }, "Fermer") : null),
                            React.createElement("div", { className: "fr-modal__content" },
                                modaleTitre,
                                modaleContent),
                            modaleFooter)))))));
};
export default Modale;
